<template>
  <div class="country-card card-condition connection-type" :class="{ noteq: predicate === 'NOT_EQUALS' }">
    <div v-if="loading" class="loading-overlay">
      <loading-circle width="32" height="32" layout="inline" />
      {{ title }}...
    </div>
    <ui-icon @click="emit('close')" size="12" icon="fas fa-times" class="card-condition__close" />

    <ui-radio-group style-type="inline" class="mb-16" v-model="predicate" v-if="!loading" :label="title">
      <div class="d-flex align-baseline ml-16">
        <ui-radio value="EQUALS" :label="t('Equals')" />
        <ui-radio class="ml-16" value="NOT_EQUALS" :label="t('Not equal')" />
      </div>
    </ui-radio-group>
    <div class="connection-type__chech-group" v-if="!loading">
      <ui-checkbox class="mb-8" v-model="includeUnknown" :label="t('Include unknown')" />
    </div>

    <div class="country-card__search" v-if="!loading">
      <ui-select
        v-model="selected"
        @blur:textarea="onBlur"
        v-model:search-input="search"
        @update:search-input="search = $event"
        :placeholder="searchPlaceholder"
        :items="items"
        item-title="name"
        :return-object="isNameCountry"
        :hide-details="2"
        multiple
        chips
        multi-line
        :custom-info="t('This option allows to specify the significant number of values. Each value should start from the new line.')"
        :with-custom-area="withCustomArea"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import LoadingCircle from '@/components/loading-circle.vue';
import { useFlowDictionaryCondition } from './useFlowDictionaryCondition';

const props = defineProps<{
  conditions: Record<string, {
    predicate: string;
    includeUnknown?: boolean;
    values: unknown[];
  }>;
  target?: unknown;
  api: string;
  title: string;
  withCustomArea?: boolean;
  searchPlaceholder: string;
  name: string;
  allowCustom?: boolean;
}>();

const emit = defineEmits<{
  close: [];
}>();

const {
  t,
  search,
  predicate,
  items,
  loading,
  includeUnknown,
  selected,
  isNameCountry,
  onBlur,
} = useFlowDictionaryCondition(props);
</script>

<style lang="scss"></style>
